/**
 * 施工事例セクション - 「もっと見る」フェード展開機能
 * sections/a-construction.liquid で使用
 *
 * 初期状態: 最初の N 件のみ表示し、残りはくすみフェードで見切れ。
 * ボタンクリックで全件展開 / 折りたたみ。
 */

(() => {
  const init = () => {
    const wrapper = document.getElementById("a-construction-list-wrapper");
    const btn = document.querySelector(".a-construction-more-btn");

    if (!wrapper || !btn) return;

    const visibleCount = parseInt(wrapper.getAttribute("data-visible-count"), 10) || 3;
    const items = wrapper.querySelectorAll("ul > li");

    if (items.length <= visibleCount) return;

    const openText = btn.getAttribute("data-open-text") || "もっと見る";
    const closeText = btn.getAttribute("data-close-text") || "閉じる";
    const peekAmount = 50;
    let isOpen = false;

    const setClipHeight = () => {
      if (isOpen) return;
      const lastVisible = items[visibleCount - 1];
      const wrapperRect = wrapper.getBoundingClientRect();
      const lastRect = lastVisible.getBoundingClientRect();
      const clipHeight = lastRect.bottom - wrapperRect.top + peekAmount;
      wrapper.style.maxHeight = clipHeight + "px";
    };

    setClipHeight();

    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (!isOpen) setClipHeight();
      }, 100);
    });

    wrapper.addEventListener("transitionend", (e) => {
      if (e.propertyName !== "max-height") return;
      if (isOpen) {
        wrapper.style.maxHeight = "none";
      }
    });

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      isOpen = !isOpen;

      if (isOpen) {
        wrapper.style.maxHeight = wrapper.scrollHeight + "px";
        wrapper.classList.add("is-open");
        btn.textContent = closeText;
        btn.setAttribute("aria-expanded", "true");
      } else {
        wrapper.style.maxHeight = wrapper.scrollHeight + "px";
        void wrapper.offsetHeight;
        setClipHeight();
        wrapper.classList.remove("is-open");
        btn.textContent = openText;
        btn.setAttribute("aria-expanded", "false");
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
